import dynamic from 'next/dynamic';

import type { MembershipBannerSectionProps } from 'src/components/sections/MembershipBannerSection/MembershipBannerSection';
import type { SectionRenderer } from 'src/types/Section';
import type { Transformer } from 'src/types/Transformer';
import type { MembershipBannerSectionContent } from './types';

export const renderer: SectionRenderer<MembershipBannerSectionProps> =
  dynamic<MembershipBannerSectionProps>(() =>
    import('src/components/sections/MembershipBannerSection/MembershipBannerSection').then(
      (mod) => mod.MembershipBannerSection,
    ),
  );

export const transformer: Transformer<
  MembershipBannerSectionContent,
  MembershipBannerSectionProps
> = (content, { pageConfig }) => {
  const [refContent] = content.membership_banner_content_reference;
  const referencedContentMissing = !refContent.heading;

  if (referencedContentMissing) {
    return {
      uid: content._metadata.uid,
      props: {
        backgroundImageUrl: '',
        buttonHref: '',
        buttonText: '',
        copy: '',
        heading: '',
        trackingTitle: content.tracking_title,
        trackingCategory: pageConfig.trackingCategory,
      },
      errors: [
        { message: 'Referenced membership banner content is missing.', preventRender: true },
      ],
    };
  }

  return {
    uid: content._metadata.uid,
    props: {
      backgroundImageUrl: refContent.background_image?.url || '',
      buttonHref: refContent.button_href,
      buttonText: refContent.button_text,
      copy: refContent.copy,
      heading: refContent.heading,
      trackingTitle: content.tracking_title,
      trackingCategory: pageConfig.trackingCategory,
    },
  };
};
